/**
 * 公共头部
 * @created on 2017/9/13
 * @author laixinyu <laixinyualex@gmail.com>
 **/
import './style.css'
import { getPlatform } from 'src/frontend-lib/tools/getPlatform'

const $platform = getPlatform()
const IS_APP = $platform.isYixinliApp || $platform.isZiXunApp

let DEFAULT_CONFIG = {
  el: document.body,
  title: '壹心理',
  button: [
    {
      icon: 'back',
      tips: '返回',
      position: 'left',
      callback() {
        window.history.back()
      }
    }
  ],
  mode: 'before' // 三种添加模式，before，after,以及 replace
}

function setHeader(options = DEFAULT_CONFIG) {
  // APP环境下隐藏公共头部
  if (IS_APP && !options.skipApp) {
    return
  }

  let $el = options.el
  let $root = $el.querySelector('.global-header.global-header-container')
  let $buttonList = options.button

  if (!$el || !($el instanceof Node)) {
    throw Error('header.js => el is not a Node!')
  }

  // 单例
  if ($root) {
    removeEvent()
    $el.removeChild($root)
  }

  $root = document.createElement('header')

  $root.className = 'global-header global-header-container'
  $root.innerHTML = `<div class="global-header global-header-list global-header-left-list"></div>
                       <div class="global-header global-header-title"><h1>${options.title}</h1></div>
                       <div class="global-header global-header-list global-header-right-list"></div>
                      `

  let $leftList = $root.querySelector(
    '.global-header-list.global-header-left-list'
  )
  let $rightList = $root.querySelector(
    '.global-header-list.global-header-right-list'
  )

  $buttonList.forEach(createBtn)
  addEvent()

  if (options.mode === 'replace') {
    $el.parentNode.replaceChild($root, $el)
  } else if (options.mode === 'after') {
    $el.appendChild($root)
  } else {
    $el.insertBefore($root, $el.firstChild)
  }

  /**
   * 增加事件监听
   */
  function addEvent() {
    $root.addEventListener('click', event)
  }

  function removeEvent() {
    $root.removeEventListener('click', event)
  }

  /**
   *
   * @param e
   */
  function event(e) {
    let target = e.target

    while (target !== $root) {
      if (
        target.tagName.toUpperCase() === 'A' &&
        target.classList.contains('global-header-btn')
      ) {
        getCallback(target)
        break
      } else {
        target = target.parentNode
      }
    }
  }

  /**
   * 创建元素
   * @param item {Object} item对象
   * @param index {Number} 当前item索引
   */
  function createBtn(item, index) {
    let _btn = document.createElement('a')
    let _customHTML = item.customHTML
    let _classList = 'global-header global-header-btn'

    _btn.setAttribute('data-index', index)

    if (item.class) {
      _classList += ` ${item.class}`
    }
    _btn.className = _classList

    if (_customHTML) {
      _btn.innerHTML = _customHTML
    } else {
      let _HTML = ''
      let _icon = item.icon
      let _tips = item.tips
      let _style = item.style

      if (_icon) {
        _HTML = `<i class="yxl-font yxl-font-${_icon}"></i>`
      }

      if (_tips) {
        _HTML += `<i style="${_style}">${_tips}</i>`
      }

      _btn.innerHTML = _HTML
    }

    if (item.position === 'right') {
      $rightList.appendChild(_btn)
    } else {
      $leftList.appendChild(_btn)
    }

    _btn = null
  }

  /**
   * 调用callback函数
   * @param el {Node} 选中元素
   */
  function getCallback(el) {
    let _index = +el.getAttribute('data-index')
    let callback = $buttonList[_index].callback

    typeof callback === 'function' && callback(el)
  }
}

module.exports = setHeader



// WEBPACK FOOTER //
// ./src/public-resource/components/header/index.js